<template>
  <datepicker v-model="value" :name="name"></datepicker>
</template>

<script>
  import EditableField from "./EditableField";

  export default {
    mixins: [EditableField],
  }
</script>
